import { Event } from "../../../../../Global/Base/Events";
import { SaveResultData } from "../../../../UI.Controls/DataSource/EditableDBDataSource";
import { IFrame, IFrameWithRights } from "../IFrame";
/**
     * Rozhraní pro obecnou implementaci editovatelného framu
     *
     * @includeToDoc
     */
export interface IEditableFrame extends IFrameWithRights {
    /**
     * Informace zda je frame v editaci či ne
     */
    isEditing: boolean;
    /**
     * Informace o tom zda je frame změněný nebo ne
     */
    isChanged: boolean;
    /**
     * Frame, ktery je jen pro cteni
     */
    interactive: boolean;
    /**
     * Informace o tom zda aktuálně vybraný objekt na framu má WorkFlow akce
     */
    actualObjectHasWF?: boolean;
    /**
     * Informace o tom zde je frame editovatelný (z definice formuláře)
     */
    isEditable?: boolean;

    /**
     * Metoda pro provedeni validace
     * @param checkRecommended zda se maji kontrolovat i dopocurena pole
     * @returns true pokud je validní
     */
    validate(checkRecommended?: boolean): Promise<boolean>;

    /**
     * Maže aktualní objekt
    */
    deleteRecord(): Promise<boolean>;

    /**
     * Přepne do editačního režimu
     */
    editRecord(): Promise<boolean>;

    /**
     * Vytvoří nový záznam
     */
    newRecord(): Promise<boolean>;

    /**
     * Navratove hodnoty:
     * null - ulozeni probehlo v poradku
     * prazdne pole - ulozeni se nepodarilo, ale neni co zpracovat
     * naplene pole - vraci vyjimky, vznikle pri ukladani
     * @param id Pokud je vyplněn, uloží pouze jeden záznam. V opačném případě ukládá všechny rozeditované objekty.
     * @param checkRecommended Pokud je vyplněno, tak validuje i doporučená pole
     * @param checkPostponed Pokud je vyplněno, tak validuje i povinně odložená pole
     * @param skipValidation Pokud je true, tak klient nebude validovat pole
     * @param isFormClosing Příznak zdali se zavírá formulář
     * @param skipSavingEditContextId Příznak zdali se má ukládat editační kontext
     */
    saveRecords(id?: string, checkRecommended?: boolean, checkPostponed?: boolean, skipValidation?: boolean, isFormClosing?: boolean, skipSavingEditContextId?: boolean): Promise<SaveResultData[] | null>;

    /**
     * Zruší editaci
     */
    cancelChanges(): Promise<void>;

    /**
     * Událost volaná změnou editačního režimu
     */
    readonly editModeChanged: Event<IEditableFrame, boolean>;

}

export class IEditableFrame {
    private static _properties = ["isEditing", "isChanged", "interactive", "editModeChanged"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some((value) => !Reflect.has(instance, value)) &&
            typeof instance.validate === "function" &&
            typeof instance.deleteRecord === "function" &&
            typeof instance.editRecord === "function" &&
            typeof instance.newRecord === "function" &&
            typeof instance.saveRecords === "function" &&
            typeof instance.cancelChanges === "function" &&
            instance instanceof IFrame;
    }
}
